// extracted by mini-css-extract-plugin
export default {"utilitiesWrapper":"utilities_utilitiesWrapper__paxPi","utilitiesReturnsWrapper":"utilities_utilitiesReturnsWrapper__Ksf6J","btnDefaultWidth":"utilities_btnDefaultWidth__mYhaa"};